import "./Footer.css";
import KatroriLogo from "../../assets/images/katroriLogo.png";
import { Mail, Phone, MapPin, Linkedin, Twitter, Facebook } from "lucide-react";

const Footer = () => {
  return (
    <footer className="footer-area">
      <div className="footer-content-width">
        <div className="footer-content">
          {/* Left Section - Brand */}
          <div className="footer-brand">
            <img
              src={KatroriLogo || "/placeholder.svg"}
              alt="Katrori ITS Logo"
              className="footer-logo"
            />
          </div>

          {/* Middle Section - Contact */}
          <div className="footer-contact">
            <div className="footer-contact-item">
              <MapPin className="footer-contact-icon" />
              <span>Lipjan, Kosova</span>
            </div>
            <div className="footer-contact-item">
              <Phone className="footer-contact-icon" />
              <span>+383(0) 38 606 806</span>
            </div>
            <div className="footer-contact-item">
              <Mail className="footer-contact-icon" />
              <span>info@katrori-its.com</span>
            </div>
          </div>

          {/* Right Section - Social & Legal */}
          <div className="footer-right">
            <div className="footer-social-links">
              <a
                href="https://www.linkedin.com/company/katrori-its/?lipi=urn%3Ali%3Apage%3Ad_flagship3_search_srp_all%3BBszTvDCHQYeNYFgYS2cC7g%3D%3D"
                target="_blank"
                className="footer-social-link"
                aria-label="LinkedIn"
              >
                <Linkedin className="footer-social-icon" />
              </a>

              <a
                href="https://www.facebook.com/katrori.its"
                target="_blank"
                className="footer-social-link"
                aria-label="Facebook"
              >
                <Facebook className="footer-social-icon" />
              </a>
            </div>
            <div className="footer-links">
              <a href="#" className="footer-link">
                Privacy Policy
              </a>
              <a href="#" className="footer-link">
                Terms of Service
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Copyright */}
        <div className="footer-bottom">
          <span className="footer-copyright">
            © 2025 Katrori ITS. All rights reserved.
          </span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
